import { SET_SHIFT_KEY_STATUS } from './type';

// eslint-disable-next-line import/prefer-default-export
export const setShiftKeyPress = (pressed) => ({
  type: SET_SHIFT_KEY_STATUS,
  payload: pressed,
});
